<template>
    <c-dialog ref="dialog" mode="slide" width="1100" enable-flex mask-close @resolve="editHandle">
        <div class="channel-config">
            <!-- 安卓设备 -->
            <div class="config-section">
                <div class="section-title">
                    安卓设备
                </div>
                <div class="tier-list">
                    <div v-for="(item, index) in androidList" :key="'android_' + index" class="tier-row">
                        <span class="row-label">售出价大于等于(≥)：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.price" decimal="2" :range="[0.01, 999999]" append-text="元" :clear="false" placeholder="请输入阶梯价格"></c-input>
                        </div>
                        <span class="row-label margin-left">时</span>
                        <span class="row-label">服务费：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.rate" decimal="2" :range="[0, 999999]" append-text="元" :clear="false" placeholder="请输入服务费"></c-input>
                        </div>
                        <span class="row-label">扣减红包：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.red_packet" decimal="2" :range="[0, 999999]" append-text="元" :clear="false" placeholder="请输入扣减红包"></c-input>
                        </div>
                        <span class="row-label">临时红包：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.temp_red_packet" decimal="2" :range="[0, 999999]" append-text="元" :clear="false" placeholder="请输入临时红包"></c-input>
                        </div>
                        <a v-if="androidList.length > 1" class="link-btn delete" @click="removeTier('android', index)"><i class="tf-trash"></i> 删除</a>
                    </div>
                    <div class="add-row">
                        <a class="link-btn add" @click="addTier('android')"><i class="tf-add"></i> 增加阶梯</a>
                    </div>
                </div>
            </div>

            <!-- 苹果设备 -->
            <div class="config-section">
                <div class="section-title">
                   苹果设备
                </div>
                <div class="tier-list">
                    <div v-for="(item, index) in appleList" :key="'apple_' + index" class="tier-row">
                        <span class="row-label">售出价大于等于(≥)：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.price" decimal="2" :range="[0.01, 999999]" append-text="元" :clear="false" placeholder="请输入阶梯价格"></c-input>
                        </div>
                        <span class="row-label margin-left">时</span>
                        <span class="row-label">服务费：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.rate" decimal="2" :range="[0, 999999]" append-text="元" :clear="false" placeholder="请输入服务费"></c-input>
                        </div>
                        <span class="row-label">扣减红包：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.red_packet" decimal="2" :range="[0, 999999]" append-text="元" :clear="false" placeholder="请输入扣减红包"></c-input>
                        </div>
                        <span class="row-label">临时红包：</span>
                        <div class="input-wrap">
                            <c-input type="number" v-model="item.temp_red_packet" decimal="2" :range="[0, 999999]" append-text="元" :clear="false" placeholder="请输入临时红包"></c-input>
                        </div>
                        <a v-if="appleList.length > 1" class="link-btn delete" @click="removeTier('apple', index)"><i class="tf-trash"></i> 删除</a>
                    </div>
                    <div class="add-row">
                        <a class="link-btn add" @click="addTier('apple')"><i class="tf-add"></i> 增加阶梯</a>
                    </div>
                </div>
            </div>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'channelConfig',

    data() {
        return {
            channelId: 0,
            channelName: '',
            androidList: [],
            appleList: []
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.channelId = data && data.id ? data.id : 0;
            this.channelName = data && data.channel_name ? data.channel_name : '';

            // 初始化默认数据
            this.androidList = [this.createEmptyTier()];
            this.appleList = [this.createEmptyTier()];

            // 回填已有配置
            if (data && data.settlement_config) {
                let config = data.settlement_config;
                if (typeof config === 'string') {
                    try {
                        config = JSON.parse(config);
                    } catch (e) {
                        config = null;
                    }
                }
                if (config && typeof config === 'object') {
                    if (Array.isArray(config.android) && config.android.length > 0) {
                        this.androidList = config.android.map(item => this.formatTier(item));
                    }
                    if (Array.isArray(config.apple) && config.apple.length > 0) {
                        this.appleList = config.apple.map(item => this.formatTier(item));
                    }
                }
            }

            // 填充form表单
            this.$refs.dialog.open({
                title: '配置结算公式 - ' + this.channelName
            });
        },

        /*******创建空阶梯数据********/
        createEmptyTier() {
            return {
                price: '',
                rate: '',
                red_packet: '',
                temp_red_packet: ''
            };
        },

        /*******格式化回填阶梯数据********/
        formatTier(item) {
            return {
                price: item.price !== undefined && item.price !== null ? item.price : '',
                rate: item.rate !== undefined && item.rate !== null ? item.rate : '',
                red_packet: item.red_packet !== undefined && item.red_packet !== null ? item.red_packet : '',
                temp_red_packet: item.temp_red_packet !== undefined && item.temp_red_packet !== null ? item.temp_red_packet : ''
            };
        },

        /*******增加阶梯********/
        addTier(type) {
            if (type === 'android') {
                this.androidList.push(this.createEmptyTier());
            } else {
                this.appleList.push(this.createEmptyTier());
            }
        },

        /*******删除阶梯********/
        removeTier(type, index) {
            this.$confirm({
                type: 'warn',
                message: '是否确认删除该条阶梯价数据？',
                buttonName: '确认删除',
                cancelButton: true,
                resolve: () => {
                    if (type === 'android') {
                        this.androidList.splice(index, 1);
                    } else {
                        this.appleList.splice(index, 1);
                    }
                }
            });
        },

        /*******添加、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();

            // 校验安卓配置
            if (!this.validateTierList(this.androidList, '安卓')) {
                return;
            }
            // 校验苹果配置
            if (!this.validateTierList(this.appleList, '苹果')) {
                return;
            }

            // 按阶梯价格从小到大排序
            this.androidList.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
            this.appleList.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

            // 组装配置JSON
            const configJson = {
                android: this.androidList.map(item => ({
                    price: parseFloat(item.price),
                    rate: parseFloat(item.rate),
                    red_packet: item.red_packet === '' || item.red_packet === null || item.red_packet === undefined ? null : parseFloat(item.red_packet),
                    temp_red_packet: item.temp_red_packet === '' || item.temp_red_packet === null || item.temp_red_packet === undefined ? null : parseFloat(item.temp_red_packet)
                })),
                apple: this.appleList.map(item => ({
                    price: parseFloat(item.price),
                    rate: parseFloat(item.rate),
                    red_packet: item.red_packet === '' || item.red_packet === null || item.red_packet === undefined ? null : parseFloat(item.red_packet),
                    temp_red_packet: item.temp_red_packet === '' || item.temp_red_packet === null || item.temp_red_packet === undefined ? null : parseFloat(item.temp_red_packet)
                }))
            };

            this.request({
                url: '/channel/config/edit',
                data: {
                    id: this.channelId,
                    settlement_config: JSON.stringify(configJson)
                },
                loading: true,
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '配置成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        },

        /*******校验阶梯数据********/
        validateTierList(list, typeName) {
            if (!list || list.length === 0) {
                this.$message({
                    message: typeName + '设备至少需要存在一条阶梯价数据',
                    type: 'warn'
                });
                return false;
            }

            const priceSet = new Set();
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                const rowText = typeName + '设备第' + (i + 1) + '行';

                // 阶梯价格必填且必须大于0
                if (item.price === '' || item.price === null || item.price === undefined) {
                    this.$message({
                        message: rowText + '的阶梯价格必填',
                        type: 'warn'
                    });
                    return false;
                }
                const price = parseFloat(item.price);
                if (isNaN(price) || price <= 0) {
                    this.$message({
                        message: rowText + '的阶梯价格必须输入大于0的数字',
                        type: 'warn'
                    });
                    return false;
                }

                // 服务费必填
                if (item.rate === '' || item.rate === null || item.rate === undefined) {
                    this.$message({
                        message: rowText + '的服务费必填',
                        type: 'warn'
                    });
                    return false;
                }
                // 服务费是该档位的固定扣减金额（元），不是百分比，不能按0-100限制
                const rate = parseFloat(item.rate);
                if (isNaN(rate) || rate < 0) {
                    this.$message({
                        message: rowText + '的服务费必须输入不小于0的数字',
                        type: 'warn'
                    });
                    return false;
                }

                // 检查价格重叠
                if (priceSet.has(price)) {
                    this.$message({
                        message: typeName + '设备下阶梯价格存在重叠',
                        type: 'warn'
                    });
                    return false;
                }
                priceSet.add(price);
            }

            return true;
        }
    }
}
</script>

<style lang="stylus" scoped>
.channel-config
    padding 20px

/*******分块卡片********/
.config-section
    width 1000px
    margin-bottom 20px
    padding 14px 20px 18px
    background-color #fff
    border 1px solid #e6ebf2
    border-radius 8px
    box-shadow 0 1px 3px rgba(31, 45, 61, 0.05)
    &:last-child
        margin-bottom 0

/*******分块标题：左侧主色竖条 + 加重标题文字，勾选框仅表示该分块固定启用********/
.section-title
    position relative
    display flex
    align-items center
    margin-bottom 12px
    padding 0 0 12px 11px
    border-bottom 1px solid #eef1f6
    font-size 16px
    font-weight 600
    color #1f2d3d
    &:before
        content ''
        position absolute
        left 0
        top 0px
        width 3px
        height 16px
        border-radius 2px
        background var(--color-main)
    /deep/ .c-checkbox-check
        border-color #b9d3f5 !important
        background #f0f7ff !important
    /deep/ .c-checkbox-content
        font-size 14px
        font-weight 600
        color #1f2d3d

/*******阶梯行：标签紧跟自己的输入框，与上一组拉开距离********/
.tier-row
    display flex
    align-items center
    flex-wrap wrap
    gap 10px 6px
    margin-bottom 0
    padding 9px 0
    border-bottom 1px dashed #f0f2f5
    &:last-child
        padding-bottom 6px
        border-bottom none

    .row-label
        white-space nowrap
        margin 0 2px 0 14px
        padding 0
        font-size 14px
        color #5f6b7d
        flex-shrink 0
        &:first-child
            margin-left 0
        &.margin-left
            /*连接字「时」，紧贴上一个输入框，弱化它的存在感*/
            margin-left 2px
            color #a8b0bd

    .input-wrap
        width 110px
        flex-shrink 0

    /*输入框尺寸收紧，单位（元/%）做成浅灰小标签，数字作为视觉主体*/
    /deep/ .c-input
        height 34px
        margin-top 0
        border-radius 6px
    /deep/ .c-input input
        font-size 13px
        color #1f2d3d
    /deep/ .c-input input::placeholder
        color #bfc6d1
    /deep/ .c-input-text
        padding 0 9px
        border-left 1px solid #eef1f6
        background #f7f9fc
        color #8a94a6
        font-size 12px

/*******按钮：增加阶梯在 .add-row 里、删除在 .tier-row 里，所以必须写在顶层才能同时命中********/
.link-btn
    display inline-flex
    align-items center
    cursor pointer
    height 30px
    padding 0 12px
    font-size 13px
    white-space nowrap
    flex-shrink 0
    border none
    border-radius 6px
    transition all 0.15s ease
    i
        margin-right 5px
        font-size 13px
    &.add
        color #66b1ff
        background none
        &:hover
            color var(--color-main)
            background #e3f0ff
    &.delete
        margin-left auto
        height 28px
        padding 0 10px
        color #f56c6c
        background none
        &:hover
            color #f56c6c
            background #fff1f0

.add-row
    margin-top 14px
    padding-top 2px
</style>
